import {
  EuiCheckableCard,
  EuiSkeletonText,
  htmlIdGenerator,
} from "@inscopix/ideas-eui";
import { setMarketingConsent } from "django/marketingConsentDjango";
import { useState } from "react";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import { addUtilityToastSuccess } from "utils/addUtilityToastSuccess";

export interface CheckboxMarketingConsentProps {
  initialMarketingConsent: boolean;
}
export const CheckboxMarketingConsent = ({
  initialMarketingConsent,
}: CheckboxMarketingConsentProps) => {
  const [id] = useState(htmlIdGenerator("marketing-preference-checkbox")());
  const [checked, setChecked] = useState(initialMarketingConsent);
  const [loading, setLoading] = useState(false);

  const handleChange = async () => {
    setLoading(true);
    try {
      const preference = await setMarketingConsent(!checked);
      setChecked(preference);
      addUtilityToastSuccess("Updated communication preference");
    } catch (err) {
      addUtilityToastFailure("Failed to updated communication preference");
    }
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <EuiSkeletonText lines={2} />
      ) : (
        <EuiCheckableCard
          id={id}
          label={
            "Check here if you agree to be contacted by Inscopix and Bruker about IDEAS and other related products."
          }
          checkableType="checkbox"
          checked={checked}
          onChange={() => {
            void handleChange();
          }}
          // prevent double request when clicking directly on the checkbox
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
          }}
        />
      )}
    </>
  );
};
